import React from 'react';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Badge from '@material-ui/core/Badge';

import WhsOrdersListContainer from './whsOrdersList/WhsOrdersListContainer'

interface WhsMainProps {
  classes: any;
  value: string;
  handleChange: (event: any, value: string) => void;
  numbersImport: number;
  numbersExport: number;
  numbersRfs: number;
  numbersGo: number;
  setCounts: Function;
};
const styles = (theme: Theme) =>

  createStyles({
    appBar: {
      justifyContent: 'center',
      marginTop: '40px',
      borderRadius: '15px'
    },
    activeTab: {
      backgroundColor: 'rgb(66, 183, 70)',
      color: 'white',
      borderRadius: '15px'
    },
    inactiveTab: {
      opacity: 0.3,
      backgroundColor: 'var(--primaryblue)',
      color: 'white',
      borderRadius: '15px'

    },
    indicator: {
      height: '0px',
    },
    badge: {
      '&>span': { 
        backgroundColor: 'red',
        color: 'var(--primaryblue)',
        marginTop: '12px',
        marginRight: '-24px'
      }
    }
  });

const WhsMain = (props: WhsMainProps) => {

  const { classes } = props;

  return (

    <div >
      <AppBar position="static" className={ classes.appBar }>
        <Tabs 
          value={ props.value }
          onChange={ props.handleChange }
          classes={{ indicator: classes.indicator }}
          variant='fullWidth'
        >
          <Tab 
            value='po'
            label={ <Badge className={ classes.badge } color="secondary" badgeContent={ props.numbersImport }> Pick Ups</Badge> }
            className={ props.value === 'po'? classes.activeTab: classes.inactiveTab }
          />
          <Tab 
            value='do'
            label={ <Badge className={ classes.badge } color="secondary" badgeContent={ props.numbersExport }> Drop Offs</Badge> }
            className={ props.value === 'do'? classes.activeTab: classes.inactiveTab }
          />
          <Tab 
            value='rfs'
            label={ <Badge className={ classes.badge } color="secondary" badgeContent={ props.numbersRfs }>RFS</Badge> }
            className={ props.value === 'rfs'? classes.activeTab: classes.inactiveTab }
          />
          <Tab 
            value='go'
            label={ <Badge className={ classes.badge } color="secondary" badgeContent={ props.numbersGo }>GO Orders</Badge> }
            className={ props.value === 'go'? classes.activeTab: classes.inactiveTab }
          />
        </Tabs>
      </AppBar>
      <WhsOrdersListContainer type={props.value} setCounts={props.setCounts}/>
    </div>
  );
}

export default withStyles(styles)(WhsMain);